import { SET_GROUP_AVAILABILITY_DATA } from '../actions/setGroupAvailabilityData'
import { RESET_ACTIVE_PACKAGES } from '../actions/resetQuoteFlow'
import { CLEAR_PACKAGE_DATA } from '../actions/fetchPackages'

const initialState = {}

export default function groupAvailabilityReducers(state = initialState, action) {
  switch (action.type) {
    case SET_GROUP_AVAILABILITY_DATA:
      return {
        ...state,
        [action.payload.key]: action.payload.data
      }
    case RESET_ACTIVE_PACKAGES:
    case CLEAR_PACKAGE_DATA:
      return initialState
    default:
      return state
  }
}
